import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { media as oldMedia } from 'legacyComponents/styled/styleUtils';
import PropTypes from 'prop-types';

import { Editor } from 'libs/editor';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';
import { BaseEditField } from 'legacyComponents/styled/lib';

const Wrapper = styled.div`
  min-height: 100px;
  color: ${props => props.theme.color.wfBlack};
  font-size: ${props => props.theme.font.size.default};
  margin-bottom: ${props => props.theme.spacing.default};
  line-height: 1.5;
  position: relative;
  a {
    &:hover {
      text-decoration: none;
    }
  }
  ${oldMedia.xs`
    font-size: ${props => props.theme.font.size.medium};
  `};
`;

const DescriptionInput = styled(BaseEditField)`
  width: 100%;
  height: 100px;
  font-size: ${props => props.theme.font.size.default};
  line-height: 1.5;
  margin-bottom: ${props => props.theme.spacing.default};
  margin-top: -${props => props.theme.spacing.small};
  overflow-y: auto;
  padding: ${props => props.theme.spacing.small};
`;

export const ProjectDescription = observer(({ app, formStore, fieldName }) => {
  if (!app.editing) {
    const store = new EditorStore({
      initialValue: html.deserialize(app[fieldName] || '<p></p>'),
      formatting: 'advanced',
    });
    return (
      <Wrapper>
        <Editor store={store} />
      </Wrapper>
    );
  }
  return (
    <EditorField
      fieldStore={formStore.fieldStores.get(fieldName)}
      editComponent={DescriptionInput}
      paragraphSpacing='paragraphSpacing12'
      noValidation
      type='text'
      className='lightBorder'
      noFormattingHint
    />
  );
});

ProjectDescription.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.string,
  editing: PropTypes.bool,
  handleChange: PropTypes.func,
  app: PropTypes.object,
};
